<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  modelValue: {type: String, required: true},
  label: {type: String},
  id: {type: String}
});
const emit = defineEmits(['update:modelValue'])
const isInputFocused = ref(false);

const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

</script>
<script>
export default {
  inheritAttrs: false,
  name: "DpInput"
}
</script>

<template>
  <div class="dp-input">
    <label v-if="props.label" :for="props.id">{{ props.label }}</label>
    <div class="dp-input__input-frame dp-flex" :class="{'focus-visible': isInputFocused}">
      <input v-bind="$attrs"
             :id="props.id"
             v-model="value"
             @focus="isInputFocused = true"
             @blur="isInputFocused = false"/>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>